import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { EmptyState } from '../empty-state';
interface NoFavoritesStateProps {
  title?: string;
  message?: string;
  className?: string;
}
export const NoFavoritesState: React.FC<NoFavoritesStateProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <EmptyState type="favorites" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};